const useTidioChat = () => {
  const open = () => {
    if (!window.tidioChatApi) return;

    window.tidioChatApi.show();
    window.tidioChatApi.open();
  };

  return { open };
};

export default useTidioChat;
